module.exports = __webpack_public_path__ + "static/img/tp.ef84fc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/medicine/tp.png
// module id = 7IPi
// module chunks = 1